var Loyers_Eligibilite = {
	init:function(){
		$(window).resize(function(){
			Loyers_Eligibilite.resize();	
		});

		Loyers_Eligibilite.resize();
	},
	resize:function(){
		var _carousel = $(".product-eligibilite .carousel-eligibilite");

		if (_carousel.hasClass('slick-initialized')) {
			_carousel.slick('unslick');
		}

		//var _slides_to_show = parseInt($("[slider-3-columns]").css("padding-top"));

		var _slides_to_show = 1;
		var els = document.querySelectorAll(".carousel-eligibilite");

		Array.prototype.forEach.call(els, function(el) {
			//Debug.log("SLIDES TO SHOW : " + el + " => " + parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide")));
			
			_slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));
			
		});

		

		_carousel.slick({
			arrows:false, 
			dots:true,
			infinite: false,
			variableWidth:true,
			slidesToShow: _slides_to_show,
			focusOnSelect: true,
			touchThreshold:500
		});	
	}
}
$(window).load(function(){
	if($(".product-eligibilite").length){
		Loyers_Eligibilite.init();
	}
});